module.exports = __webpack_public_path__ + "img/house_new.2761194a.svg";